import { useEffect, useRef, useState } from 'react'

/** Ширина элемента в пикселях (ResizeObserver); `0`, пока не измерена. */
export const useElementWidth = <T extends HTMLElement>() => {
  const ref = useRef<T>(null)
  const [width, setWidth] = useState(0)
  useEffect(() => {
    const node = ref.current
    if (!node || typeof ResizeObserver === 'undefined') return
    const ro = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width))
    ro.observe(node)
    setWidth(node.getBoundingClientRect().width)
    return () => ro.disconnect()
  }, [])
  return { ref, width }
}
